export enum AuthenticQuizResults {
  TIME = '47c6020f-6ddf-4725-93f5-5aa0a5fcfa64',
  CONNECTIONS = '998129ac-1f6f-4858-a3da-c93c4e01bf90',
  SKILLS = 'f5eb91ed-96ac-4fc6-8aa5-7135b4c19543',
  MONEY = '3af5aba5-1754-401c-b529-02d18155763a',
  DISCIPLINE = '8c907c30-0daa-4b60-8589-54325aaaf6f2',
  MONSTERS = '44afe852-af8e-45c3-9689-504040eb9c27',
}
